import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export class BusquedaService {

	private busqueda 		= 	new Subject<any>();
	private cleanbusqueda	= 	new Subject<any>();

	notifyObservable$ 		= this.busqueda.asObservable();
	notifyObservableClean$ 	= this.cleanbusqueda.asObservable();

	constructor() { }

	public notificarBusqueda(data: any) {
		if (data) {
			this.busqueda.next(data);
		}
	}

	public cleanBusqueda(){
		this.cleanbusqueda.next();
	}
}

@Injectable({
	providedIn: 'root'
})

export class SelectCampanaService {

	private selcampana = new Subject<any>();

	notifyObservableSC$ = this.selcampana.asObservable();

	constructor() { }

	public notificarSCampana(data: any) {
		if (data) {
			this.selcampana.next(data);
		}
	}
}
